import { instance } from '@/libs/api/instance'

/**
 * Get detailed information about wallet
 *
 * @param {string} id - Wallet UUID
 * @param {object} [params] - Wallet expansions
 * @param {string} [params.expand] - Comma-separated relations
 * @return {Promise<AxiosResponse<any>>}
 */
export const getDetails = (
  id,
  {
    expand = [
      'currency',
      'transferSourceWalletId',
      'transferTargetWalletId',
    ].join(','),
  } = {},
) => {
  return instance.get(`/v3/wallet/${id}`, {
    params: {
      expand,
    },
  })
}
